<template>
  <v-row justify="center">
    <v-dialog v-model="theDialog" persistent value="" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add/Merge Customer</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col class="py-1" cols="12" sm="12">
                  <v-autocomplete
                    v-model="customerValue"
                    autocomplete="off"
                    :search-input.sync="customerSearchTerm"
                    no-filter
                    :items="customersList"
                    item-text="name"
                    item-value="id"
                    name="customernam"
                    label="Customer"
                    dense
                    no-data-text="No customers to choose from"
                    :append-outer-icon="
                      customerValue && customerValue != 'new'
                        ? 'mdi-open-in-new'
                        : null
                    "
                    @click:append-outer="onOpenCustomer"
                    autofocus
                    outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
            >Delete</v-btn
          >-->
          <v-btn
            color="primary tile"
            @click="onSave"
            v-if="customerValue && customerValue != 'new'"
            >&nbsp;&nbsp;&nbsp;Merge&nbsp;&nbsp;&nbsp;</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Fuse from "fuse.js";
import { CUSTOMER_SEARCH_FUSE_OPTIONS } from "../../../globalVars";

export default {
  name: "ContactMergeModal",
  props: {
    ContactInfoDetails: String,
    CustomerSource: Number
  },
  components: {},
  data: () => ({
    theDialog: true,
    customerSearchTerm: null,
    customerValue: null
  }),
  computed: {
    user() {
      return this.$store.getters["entities/users/find"](
        this.$store.getters["entities/settings/query"]().first().userId
      );
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    customerLookup() {
      return this.$store.getters["entities/customerLookups/query"]()
        .orderBy("date", "desc")
        .get();
    },
    customersList() {
      let newList;
      if (!this.customerSearchTerm && this.customerValue) {
        newList = this.customerLookup;
      } else if (!this.customerSearchTerm) {
        newList = this.customerLookup.slice(0, 100);
      } else {
        let fuse = new Fuse(this.customerLookup, CUSTOMER_SEARCH_FUSE_OPTIONS);
        newList = fuse.search(this.customerSearchTerm).slice(0, 100);
      }
      newList.push({
        id: "new",
        name: "- Add New Customer -"
      });
      return newList;
    }
  },
  created() {
    if (this.customersList && this.customersList.length == 1) {
      this.onAddNewCustomer();
    }
  },
  methods: {
    onClose() {
      this.$root.$children[0].showCustomerEditorModals = false;
    },
    onSave() {
      let vueThis = this;
      let timer = setInterval(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          clearInterval(timer);
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.ContactInfoDetails = vueThis.ContactInfoDetails;
          theContainer.ContactInfoType = "phone";
          theContainer.CustomerId = vueThis.customerValue;
          theContainer.showContactInfoFormModal = true;
        }
      }, 100);
    },
    onAddNewCustomer() {
      let vueThis = this;
      let timer = setInterval(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          clearInterval(timer);
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.CustomerId = -1;
          theContainer.PhoneNumber = vueThis.ContactInfoDetails;
          theContainer.CustomerSource = vueThis.CustomerSource;
          theContainer.showCustomerDetailFormModal = true;
        }
      }, 100);
    },
    onOpenCustomer(id) {
      if (id && this.customerValue) {
        this.$store.dispatch("entities/customers/clickCustomer", {
          customerId: this.customerValue
        });
        this.$store.dispatch("entities/users/update", {
          where: this.user.id,
          data: { currentCustomerId: this.customerValue }
        });
        this.$root.$children[0].showCustomerEditorModals = false;
        let vueThis = this;
        this.$nextTick(() => {
          vueThis.$router.push({ name: "customers" });
        });
      }
    }
  },
  watch: {
    customerValue: function(after, before) {
      if (after == "new") {
        this.onAddNewCustomer();
      }
    }
  }
};
</script>

<style scoped lang="stylus"></style>
